const Images: string[] = [
  require('../Diary/images/Truffer_Bild-1.jpg'),
  require('../Diary/images/Truffer_Bild-2.jpg'),
  require('../Diary/images/Truffer_Bild-3.jpg'),
  require('../Diary/images/Truffer_Bild-4.jpg'),
  require('../Diary/images/Truffer_Bild-5.jpg'),
  require('../Diary/images/Truffer_Bild-6.jpg'),
  require('../Diary/images/Truffer_Bild-7.jpg'),
  require('../Diary/images/Truffer_Bild-8.jpg'),
  require('../Diary/images/Truffer_Bild-9.jpg'),
  require('../Diary/images/Truffer_Bild-10.jpg'),
  require('../Diary/images/Truffer_Bild-11.jpg'),
  require('../Diary/images/Truffer_Bild-12.jpg'),
  require('../Diary/images/Truffer_Bild-13.jpg'),
  require('../Diary/images/Truffer_Bild-14.jpg'),
]

export const Diary_DE: {
  title: string
  entries: [string, string, string[]][]
} = {
  title: 'Martin Truffers Reise-Album zum Thwaites-Gletscher',
  entries: [
    [
      'Abreise in Christchurch',
      'In Neuseeland besteigen Martin Truffer und sein Team im November 2019 eine C-17 der US-Luftwaffe…',
      [Images[0], Images[1]],
    ],

    [
      'Ankunft in der Antarktis',
      '… und erreichen nach einem fünfstündigen Flug die amerikanische McMurdo-Station ganz im Westen der Westantarktis. McMurdo ist die grösste Logistikbasis auf dem Kontinent.',
      [Images[2], Images[3]],
    ],

    [
      'Endlich geht’s weiter!',
      'Mitte Dezember 2019 – nach vier Wochen in McMurdo – hat das Warten auf gutes Wetter ein Ende: Eine C-130 Hercules fliegt Martin Truffer & Co. in sechs Stunden zu einem Camp auf 2000 Metern über Meer. Es ist die letzte Zwischenstation auf dem Weg zum Thwaites-Gletscher.',
      [Images[4], Images[5]],
    ],

    [
      'Die letzte Etappe',
      'Noch am gleichen Tag erreicht das Team endlich sein Ziel: Mit einer Twin Otter – das ist eine kleine Propellermaschine, die für sehr kurze Start- und Landebahnen optimiert ist – fliegt es in zwei Stunden zum Thwaites-Gletscher. Und landet: im Nichts. Zuallererst muss man nun sicherstellen, dass alles Equipment eingetroffen ist…',
      [Images[6], Images[7]],
    ],

    [
      'Erst die Arbeit, dann die Arbeit',
      '… gleich danach errichtet man Zelte, schmilzt Schnee zu Wasser, stellt Generatoren auf, verlegt Kabel (im Bild links die erste Mahlzeit nach dem Aufbau). Erst dann kann die eigentliche Arbeit beginnen (im Bild rechts ein Teil des Heisswasserbohrers, mit dem Martin Truffer Löcher ins Eis macht, um an das untere Ende des Eisschelfs zu gelangen).',
      [Images[8], Images[9]],
    ],
    [
      'Kurze (fotografische) Auszeiten',
      'Viel Freizeit bleibt in den fünf Wochen auf dem Thwaites-Gletscher bis zur Abreise im Januar 2020 nicht. Für die vielen verschiedenen antarktischen Wolkenformationen hat Martin Truffer allerdings immer einen Blick.',
      [Images[10], Images[11], Images[12], Images[13]],
    ],
  ],
}
export const Diary_FR: {
  title: string
  entries: [string, string, string[]][]
} = {
  title: 'Album de voyage de Martin Truffer au glacier Thwaites',
  entries: [
    [
      'Départ de Christchurch',
      "En Nouvelle-Zélande, Martin Truffer et son équipe montent à bord d'un C-17 de l'armée de l'air américaine en novembre 2019...",
      [Images[0], Images[1]],
    ],

    [
      'Arrivée en Antarctique',
      "... et arrivent après un vol de cinq heures à la station américaine de McMurdo, tout à l'ouest de l'Antarctique occidental. McMurdo est la plus grande base logistique du continent.",
      [Images[2], Images[3]],
    ],

    [
      'Enfin, on continue!',
      "Mi-décembre 2019, après quatre semaines à McMurdo, l'attente du beau temps prend fin: un C-130 Hercules transporte Martin Truffer et son équipe en six heures vers un camp situé à 2000 mètres d'altitude. C'est la dernière étape intermédiaire sur la route du glacier Thwaites et en quelque sorte le dernier avant-poste de la civilisation. Il se compose de containers et de quelques tentes.",
      [Images[4], Images[5]],
    ],

    [
      'La dernière étape',
      "Le même jour, le groupe atteint enfin son but: à bord d'un Twin Otter, un petit avion à hélice optimisé pour des pistes très courtes, il s'envole en deux heures vers le glacier Thwaites. Et atterrit dans le vide. La première chose à faire est de s'assurer que tout l'équipement est arrivé...",
      [Images[6], Images[7]],
    ],

    [
      'Du travail et encore du travail',
      "... tout de suite après, on monte des tentes, on fait fondre la neige pour en faire de l'eau, on installe des générateurs, on pose des câbles (sur la photo de gauche, le premier repas après le montage). Ce n'est qu'ensuite que le véritable travail peut commencer (sur la photo de droite, une partie de la foreuse à eau chaude avec laquelle Martin Truffer fait des trous dans la glace pour atteindre l'extrémité inférieure de la plateforme de glace).",
      [Images[8], Images[9]],
    ],
    [
      'Courtes pauses (photographiques)',
      "Il ne reste pas beaucoup de temps libre pendant les cinq semaines passées sur le glacier Thwaites jusqu'au départ en janvier 2020. Mais Martin Truffer a toujours un œil sur les nombreuses formations nuageuses de l'Antarctique.",
      [Images[10], Images[11], Images[12], Images[13]],
    ],
  ],
}
